<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fileForm: () => import('../forms/FileForm'),
                pestControlForm: () => import('../forms/PestControlForm'),
                fields: [
                    { type: 'autocomplete', text: 'Pest Control', value: 'pestControlId', rules: [v => !!v || 'Pest Control is required'], isRequired: true, form: () => import('./PestControlForm'), apiMethod: 'PestControls', claim: 'PestControls' },
                    { type: 'file', text: 'File', value: 'fileId', rules: [v => !!v || 'File is required'], isRequired: true, form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'PestControlFiles',
                formTitle: 'Pest Control File',
            }
        },
    };
</script>
